module.exports = __webpack_public_path__ + "img/icon-user-black.92c1ca2a.svg";